/**
 * Helper function to get the full image URL from a relative path
 * Handles various image URL formats
 */
export const getImageUrl = (imageUrl) => {
  if (!imageUrl) {
    return 'https://via.placeholder.com/400x300?text=Imagen+no+disponible';
  }
  
  // If it's already a full URL (http/https), return as is
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    return imageUrl;
  }
  
  // If it's a data URL (base64), return as is
  if (imageUrl.startsWith('data:')) {
    return imageUrl;
  }
  
  // Get backend URL from environment
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
  
  // Convert /uploads/ to /api/uploads/ for proper routing through ingress
  let cleanImageUrl = imageUrl;
  if (imageUrl.startsWith('/uploads/')) {
    cleanImageUrl = '/api' + imageUrl;
  } else if (!imageUrl.startsWith('/api/uploads/') && !imageUrl.startsWith('/')) {
    cleanImageUrl = '/api/uploads/' + imageUrl;
  }
  
  // Ensure no double slashes
  const cleanBackendUrl = backendUrl.endsWith('/') ? backendUrl.slice(0, -1) : backendUrl;
  
  return `${cleanBackendUrl}${cleanImageUrl}`;
};

/**
 * Format price in Mexican Pesos
 */
export const formatPrice = (price) => {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 0
  }).format(price);
};
